// extracted by mini-css-extract-plugin
module.exports = {"chessboardStyle":"Practice_chessboardStyle__3AQcl"};